import { Link } from "react-router-dom";
import { Home, Radar } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-5 py-20" data-testid="not-found-page">
      <Radar className="w-14 h-14 text-[#22d3ee] mb-6 animate-pulse" />
      <p className="heading text-7xl sm:text-8xl text-white leading-none">4<span className="text-[#67e8f9]">0</span>4</p>
      <h1 className="heading text-3xl text-white mt-4">Zona non mappata</h1>
      <p className="font-rajdhani text-gray-400 text-base mt-2 max-w-md">
        La pagina che cerchi è fuori dai confini della mappa. Ritorna alla base per continuare la missione.
      </p>
      <Link to="/seals-of-warzone" data-testid="notfound-home-link" className="btn-cyber clip-hud px-6 py-2.5 text-sm flex items-center gap-2 mt-8">
        <Home className="w-4 h-4" /> Torna alla Home
      </Link>
    </div>
  );
}
